import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import AuthorCard from '../Card/AuthorCard';
import BookCard from '../BookSlider/BookCard';
import QuoteCard from './QuoteCard';

import "./CardSlider.css";

const renderSlides = (props) => {
  let slides = props.slides,
      cardType = props.cardType,
      slidesPerView = props.slidesPerView || 1;

  // For author cards, group them based on screen size
  if (cardType.toLowerCase() === 'authorcard' && slidesPerView > 1) {
    const groupedSlides = [];
    
    // Group into sets based on slidesPerView
    for (let i = 0; i < slides.length; i += slidesPerView) {
      const group = slides.slice(i, i + slidesPerView);
      groupedSlides.push(
        <div key={i} className="author-group-slide">
          <div className={`author-group-container ${slidesPerView === 5 ? 'author-group-desktop' : ''}`}>
            {group.map((card, index) => (
              <div key={index} className="author-item">
                <AuthorCard
                  author={card}
                  showRemoveButton={false}
                  showListHeader={true}
                  setOpen={props.setOpen}
                  setAuthor={props.setAuthor}
                  setAuthorId={props.setAuthorId}
                />
              </div>
            ))}
          </div>
        </div>
      );
    }
    return groupedSlides;
  }

  // Default behavior for other card types or single slide view
  return slides.map((card, key) => {
    switch (cardType.toLowerCase()) {
    case 'bookcard':
      return (
        <div key={key}>
          <BookCard
            image={card.Image}
            title={card.Title}
            description={card.Description}
            authors={card.Author}
            isbn={card.Primary_ISBN}
            imageClasses={"large-4  medium-4 small-12"}
            detailsClasses={"large-8 medium-8 small-12"}
          />
        </div>
      );
    case 'authorcard':
      return (
        <div key={key}>
          <AuthorCard
            author={card}
            showRemoveButton={false}
            showListHeader={true}
            setOpen={props.setOpen}
            setAuthor={props.setAuthor}
            setAuthorId={props.setAuthorId}
          />
        </div>
      );

    case 'quote':
      return (
        <div key={key}>
          <QuoteCard
            quote={card}
          />
        </div>
      );
    default:
      return (
        <div></div>
      )
    }
  });
};


const CardSlider = (props) => {
  const {
    arrows = true,
    dots = false,
    infinite = true, // should the gallery wrap around it's contents
    autoplay = true,
    initialSlide = 0, // which item should be the first to be displayed
    autoplaySpeed = 3000,
    className = 'card-slider',
  } = props;

  const slides = renderSlides(props);

  return (
    <React.Fragment>
      <Carousel
        showArrows={arrows}
        showIndicators={dots}
        infiniteLoop={infinite}
        autoPlay={autoplay}
        interval={autoplaySpeed}
        selectedItem={initialSlide}
        showStatus={false}
        showThumbs={false}
        swipeable={true}
        emulateTouch={true}
        className={className}
      >
        {slides}
      </Carousel>
    </React.Fragment>
  )
}

CardSlider.propTypes = {
  slides: PropTypes.array,
  cardType: PropTypes.string,
  arrows: PropTypes.bool,
  dots: PropTypes.bool,
  infinite: PropTypes.bool,
  swipeToSlide: PropTypes.bool,
  autoplay: PropTypes.bool,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  initialSlide: PropTypes.number,
  autoplaySpeed: PropTypes.number,
  className: PropTypes.string,
  lazyLoad: PropTypes.bool,
  draggable: PropTypes.bool,
  centerMode: PropTypes.bool,
  pauseOnHover: PropTypes.bool,
  responsive: PropTypes.array,
  fade: PropTypes.bool,
  touchMove: PropTypes.bool,
  swipe: PropTypes.bool,
  deviceSize: PropTypes.number,
  imageSize: PropTypes.number,
  showBookInfo: PropTypes.bool,
  currentSiteID: PropTypes.number,
  postType: PropTypes.number
};

export default CardSlider;